<template>
    <div>
        <Modal
            class-name="vertical-center-modal"
            :value="showSetModel && (DataType==17)"
            :title="$t('edit')"
            :footer-hide="true"
            :mask-closable="false"
            @on-cancel="cancel"
            @on-visible-change="openOrClose"  :styles="{'min-width':'600px'}">
            
            <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80" >
                 <!-- 元素类型 -->
                 <FormItem :label="$t('BasicProduct.funcBox.titleName.ElementType')" prop="elementType" style="width: 500px;" class="dataItem">

                    <RadioGroup v-model="formData.elementType" @on-change="setElementTypeVal($event)">
                        <Radio v-for="item in elementTypeList" :label="item.id+''" :key="item.id">{{ item.val }}</Radio>
                    </RadioGroup>
    
                </FormItem>

                <template v-if="formData.elementType==13">
                    <FormItem label="struct">
                        <div style="max-height:200px;overflow-y:auto">
                            <div class="flexC" style="margin-bottom:10px" v-for="(item,index) in formData.formatContent" :key="index">
                                <div class='paramsContainer' style="width:220px;">
                                    <div class='itemContainer one-txt-cut' :title="item.LanguageKey">
                                        {{formatTypeObj[item.formatType]}}: {{item.LanguageKey}}
                                    </div>
                                </div>
    
                                <div class='operate' style="margin-left:50px ;">
                                    <div class='operating flexC' >
                                        <a @click="editTypeDiscription(item,index)" >{{isGener?$t('detail'):$t('edit')}}</a>
                                        <span style="margin:0 5px ;"> | </span>
                                        <a @click="delTypeDiscription(item,index)" :disabled="isGener" style="color:red;">{{$t('delete')}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div type="text" style="color: #2d8cf0;cursor: pointer;"  @click="showIndentyName('formatContent')">
                           {{$t('BasicProduct.addParams')}}
                        </div>
                    </FormItem>
                   
                </template>
    
                 <FormItem v-if="isGener">
                    <Button type="primary" @click="cancel">{{$t("cancel")}}</Button>
                </FormItem>
    
                <FormItem v-else>
                    <Button type="primary"  :disabled="type==3" @click="handleSubmit('formData')">{{$t('save')}}</Button>
                    <Button @click="cancel" style="margin-left: 8px">{{$t('cancel')}}</Button>
                </FormItem>
            </Form>

        </Modal>
        <StructType  :showSetModel.sync="IndentyNameBox.showSetModelStruct" :isGener="isGener" :pageId="pageId"  :type="IndentyNameBox.type" :languageKey='IndentyNameBox.key' :DataType='formData.elementType' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn"></StructType>
   
   </div>
</template>
<script>
/**
 * 弹框
 * @param showSetModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import { mapState } from 'vuex'
import StructType from './structType.vue'


    export default {
        props: {
            showSetModel: Boolean,
            fn:Function,
            type:Number,
            pageId:[Number, String],
            editFormData:Object,
            DataType:String,
            // languageKey:Object,
            // initdata:Object,
            isGener:{
                type:Boolean,
                default:false
            },
            published:{//是否发布
                type:Boolean,
                default:false
            }
        },
        components:{
            StructType
        },
        name: "ModelArrType",
        data() {
            return {   
                disabled: false,//禁用确定按钮
                formData: {
                    elementType:"16",
                    formatContent:[]
                 
                },
                elementTypeList: [
                    { id: 16, val: 'int32' },
                    { id: 15, val: 'float' },
                    { id: 1, val: 'double' },
                    { id: 4, val: 'text' },
                    { id: 13, val: 'struct' },
                ],
                IndentyNameBox:{
                    showSetModelStruct:false,
                    type:1,
                    key:{},
                    editFormData:{},
                    callbackFn:(e)=>{}
                }
            }
        },
        computed:{
            ...mapState(['local','selectId','formatTypeObj','wordList','wordListByPageId','pageIdStore']),
             ruleCustom(){
                return {//验证
                    elementType: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ]
                }
             },
          

        },
        created(){
           
        },
        methods: {
            showIndentyName(){
                if(this.isGener){
                     return
                 }
                 this.IndentyNameBox.showSetModelStruct= true;
                 this.IndentyNameBox.editFormData = {IndentyName:{},allArr:this.formData.formatContent}
                 this.IndentyNameBox.type = 1

                this.IndentyNameBox.callbackFn = (arr,text) => {//回调处理
                    console.log('addarr',arr)
                    console.log('text',text)
                    //重新载入
                    this.IndentyNameBox.showSetModelStruct= false;
                    console.log('this.formData.formatContent',this.formData.formatContent)
                    this.formData.formatContent.push(arr)
                    if(this.formData.formatContent.length){

                        this.formData.formatContent = this.formData.formatContent.map(item=>{
                            if(item.index) delete item.index
                            if(item.status) delete item.status
                            return item
                        })
                    }
                    console.log('this.formData.formatContent',this.formData.formatContent)

                }

            },
            delTypeDiscription(item,index){//删除数据类型详细
               this.formData.formatContent.splice(index,1)
            },
            editTypeDiscription(item,index){//编辑数据类型详细
                 this.IndentyNameBox.type = 2
                 this.IndentyNameBox.editFormData = {IndentyName:item,allArr:this.formData.formatContent}

                  this.IndentyNameBox.showSetModelStruct= true;
                  this.IndentyNameBox.callbackFn = (arr,text) => {//回调处理
                    //重新载入
                    // console.log('editarr',arr)
                    this.IndentyNameBox.showSetModelStruct= false;
                    this.formData.formatContent[index] = {...arr}
                }

            },
            setElementTypeVal(e){
                console.log(e)
            },
          
        
            handleSubmit (name) {
                if(this.isGener){
                    return
                }

                let obj = {
                    elementType:this.formData.elementType
                }

                // struct不能为空
                // if(this.formData.elementType == 13){

                //     if(!this.formData.formatContent.length){
                //         this.$Message.error('struct不能为空')
                //         return
                //     }
                //     obj.formatContent = [...this.formData.formatContent]
                // }

                if(this.formData.elementType == 13){

                    if(this.formData.formatContent.length){
                        obj.formatContent = [...this.formData.formatContent]
                    }
                }




                console.log('objobjobj',obj)

                
                this.fn({...obj},this.formData.elementType)
                setTimeout(()=>{
                    this.resetForm()
                },0)

                

            },
          
            openOrClose(value) {
                if(value === true) {
                    // console.log('pageId',this.pageId)
                    if(this.type==2){
                        // console.log('this.editFormData',this.editFormData)
                        // console.log('this.editFormData',{...this.editFormData.IndentyName})

                        this.formData =  common.deepClone({...this.editFormData.IndentyName}) 
                        this.formData.formatContent =   this.editFormData.IndentyName.formatContent?common.deepClone([...this.editFormData.IndentyName.formatContent]):[]
                        // this.formData.formatContent = []
                        // if(this.formData.elementType==2){
                            
                        //     let arr = [...this.editFormData.IndentyName.formatContent]
                        //     arr.map((item,index)=>{
                        //         item.status = 1
                        //         item.index = index
                            
                        //         return item
                        //     })
                        //     this.formData.formatContent = [...arr]
                        // }
                    }
                } 
            },
            cancel() {//对话框关闭
                this.$emit('update:showSetModel',false);
                this.resetForm()
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                this.formData.elementType = '16'
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>

<style lang="less" scoped>
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;

        .ivu-select-dropdown {
            max-width: 380px;
        }
    }

   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
/deep/ .ivu-input[disabled]{
    background-color: #ffffff;
    color: #515a6e;
}

</style>

